// 查询签约卡
import axiosRequest from '@/utils/request'

export const queryCard = (params) => {
  return axiosRequest({
    url: '/sign/card',
    method: 'get',
    params,
    showMessage: false
  })
}
